import { RootState } from '@app/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ILoadingState {
  isLoading: boolean;
  type: 'default' | 'indeterminate';
  isDownloading: boolean;
  downloadProgress?: {
    chunks: number;
    chunks_processed: number;
    total: number;
  };
}

const initialState: ILoadingState = {
  isLoading: false,
  type: 'default',
  isDownloading: false,
  downloadProgress: undefined,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    showLoading: (state, action: PayloadAction<'default' | 'indeterminate' | undefined>) => {
      state.isLoading = true;
      state.type = action.payload ?? 'default';
    },
    hideLoading: state => {
      state.isLoading = false;
      state.type = 'default';
    },
    startDownload: state => {
      state.isDownloading = true;
      state.downloadProgress = undefined;
    },
    updateDownloadProgress: (
      state,
      action: PayloadAction<{ chunks: number; chunks_processed: number; total: number }>,
    ) => {
      state.downloadProgress = action.payload;
    },
    completeDownload: state => {
      state.isDownloading = false;
      state.downloadProgress = undefined;
    },
  },
});

export const actions = loadingSlice.actions;
export const { showLoading, hideLoading, startDownload, updateDownloadProgress, completeDownload } =
  loadingSlice.actions;
export const selectLoading = (state: RootState) => state.loading;
export const selectDownloading = (state: RootState) => state.loading.isDownloading;
export const selectDownloadProgress = (state: RootState) => state.loading.downloadProgress;
export default loadingSlice.reducer;
